import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import WordExample from 'components/WordExample';

export const WordExampleModalComponent = ({ wordExampleResource, defaultWord, isZhuyin }) => {
    return <ExtendedContentContainer extendedContentType={ExtendedContentType.WordExample}>
        <WordExample data={wordExampleResource} defaultWord={defaultWord} isZhuyin={isZhuyin} />
    </ExtendedContentContainer>
};
